<template lang="html">
  <div :style='styles.tableContainerStyle'>
    <table class='headers' :style='styles.headerTableStyle'>
      <tr :style='styles.trStyle'>
        <th v-for='headerText in headers' :style='styles.thStyle'>
          {{ headerText.value }}
        </th>
      </tr>
    </table>
    <table class='data' :style='styles.headerTableStyle'>
      <tr v-for='row, rowKey in dataAsComputed' :style='styles.trStyle'>
        <td v-for='field, fieldKey in row' :style='styles.tdStyle' class='row'>
          <div v-if='field.editable'>
            <div v-if='field.edit'>
              <input type="text" @keyup='updateData($event, rowKey, fieldKey)' :style='styles.editableLabel' :value='(dataAsComputed[rowKey][fieldKey]).value' v-on-clickaway="resetToFalse(rowKey, fieldKey)">
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
            <div :style="styles.editableLabel" v-if='!field.edit'>
              {{ field.value }}
            </div>
            <div @click='editData(rowKey, fieldKey)' :style="styles.editableEditBox" v-if='!field.edit'>
              <i class="fa fa-pencil" aria-hidden="true"></i>
            </div>
          </div>
          <div v-if='!field.editable'>
            {{ field.value }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  // merge fix
  import { directive as onClickaway } from 'vue-clickaway'
  export default {
    directives: {
      onClickaway: onClickaway
    },
    props: ['data', 'headers', 'styles', 'handleEvent'],
    data () {
      return {
        edit: false,
        away: onClickaway,
        dataProxy: null
      }
    },
    computed: {
      dataAsComputed: {
        get () {
          let dataProxy = this.dataProxy
          this.dataProxy = null
          return dataProxy || this.data
        },
        set (value) {
          this.dataProxy = value
        }
      }
    },
    created () {
      for (let p of this.dataAsComputed) {
        for (let c of p) {
          c.edit = false
        }
      }
    },
    methods: {
      editData (rowKey, fieldKey) {
        this.dataAsComputed[rowKey][fieldKey].edit = true
        let data = this.dataAsComputed
        this.dataAsComputed = []
        this.dataAsComputed = data
      },
      resetToFalse (rowKey, fieldKey) {
        return () => {
          this.dataAsComputed[rowKey][fieldKey].edit = false
          let data = this.dataAsComputed
          this.dataAsComputed = []
          this.dataAsComputed = data
        }
      },
      updateData (e, row, col) {
        let newData = Number(e.target.value)
        this.handleEvent(this.data, newData, row, col)
      }
    }
  }
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// HorizontalTable.vue?1b8a1509